(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bni-experience-scripts"] && !Shopify.designMode) return;
  try {
    (() => {
 const reduce = matchMedia('(prefers-reduced-motion: reduce)');
 const clamp = (n,a,b) => Math.min(b,Math.max(a,n));
 function initExperience(){
  document.querySelectorAll('[data-exp-canvas]').forEach(view=>{
   if(view.dataset.initialized)return;
   view.dataset.initialized='true';
   const model=view.querySelector('.exp-canvas-model');
   const reset=view.querySelector('[data-exp-reset]');
   const space=view.querySelector('[data-exp-drag]');
   const angle=()=>{const value=parseFloat(model.style.getPropertyValue('--turn'));return Number.isFinite(value)?value:-22;};
   const turn=value=>{view.dataset.manual='true';model.style.setProperty('--turn',clamp(value,-75,75)+'deg');};
   view.querySelectorAll('[data-exp-turn]').forEach(button=>button.addEventListener('click',()=>turn(angle()+Number(button.dataset.expTurn))));
   reset.addEventListener('click',()=>{turn(0);model.style.setProperty('--lean','0deg');});
   let drag=null;
   space.addEventListener('pointerdown',event=>{
    if(event.pointerType==='mouse'&&event.button!==0)return;
    drag={id:event.pointerId,x:event.clientX,angle:angle()};
    space.setPointerCapture(event.pointerId);
   });
   space.addEventListener('pointermove',event=>{
    if(!drag||event.pointerId!==drag.id)return;
    turn(drag.angle+(event.clientX-drag.x)*.55);
   });
   const release=()=>{drag=null;};
   space.addEventListener('pointerup',release);space.addEventListener('pointercancel',release);
   space.addEventListener('lostpointercapture',release);
   space.addEventListener('dragstart',event=>event.preventDefault());
   view.querySelectorAll('[data-exp-size]').forEach(button=>button.addEventListener('click',()=>{
    const large=button.dataset.expSize==='large';model.dataset.large=String(large);
    view.querySelectorAll('[data-exp-size]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
   }));
  });
  document.querySelectorAll('[data-exp-sort]').forEach(select=>{
   if(select.dataset.initialized)return;select.dataset.initialized='true';
   select.addEventListener('change',()=>{const url=new URL(location.href);url.searchParams.set('sort_by',select.value);url.searchParams.delete('page');location.assign(url.toString());});
  });
  document.querySelectorAll('[data-exp-story]').forEach(story=>{
   if(story.dataset.initialized)return;story.dataset.initialized='true';
   const view=story.querySelector('[data-exp-canvas]'),model=story.querySelector('.exp-canvas-model');
   if(!model)return;
   let pending=false,visible=true;
   const draw=()=>{
    pending=false;if(!visible||!story.isConnected||reduce.matches)return;
    const rect=story.getBoundingClientRect();
    const travel=Math.max(1,story.offsetHeight-innerHeight+140);
    const progress=clamp((140-rect.top)/travel,0,1);
    const scene=Math.min(2,Math.floor(progress*3));story.dataset.scene=String(scene);
    if(view.dataset.manual!=='true'){
     const angle=-22+Math.sin(progress*Math.PI*2)*47;
     model.style.setProperty('--turn',angle.toFixed(2)+'deg');
     model.style.setProperty('--lean',(7-Math.sin(progress*Math.PI)*13).toFixed(2)+'deg');
    }
   };
   const update=()=>{if(!pending){pending=true;requestAnimationFrame(draw);}};
   if('IntersectionObserver' in window){const observer=new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;if(visible)update();});observer.observe(story);}
   document.addEventListener('scroll',update,{passive:true,capture:true});addEventListener('resize',update,{passive:true});reduce.addEventListener('change',update);update();
  });
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initExperience);else initExperience();
 document.addEventListener('shopify:section:load',initExperience);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bni-flow-scripts"] && !Shopify.designMode) return;
  try {
    (() => {
  function initBni() {
    const header = document.getElementById('bni-header');
    if (header && !header.dataset.ready) {
      header.dataset.ready = 'true';
      const button = header.querySelector('.bni-menu-toggle');
      const menu = document.getElementById('bni-mobile-menu');
      const close = () => { menu.hidden = true; button.setAttribute('aria-expanded', 'false'); };
      button.addEventListener('click', () => { const open = menu.hidden; menu.hidden = !open; button.setAttribute('aria-expanded', String(open)); });
      menu.querySelectorAll('a').forEach(a => a.addEventListener('click', close));
      document.addEventListener('keydown', e => { if (e.key === 'Escape' && !menu.hidden) { close(); button.focus(); } });
    }
    const home = document.querySelector('[data-bni-home]');
    if (!home || home.dataset.ready) return;
    home.dataset.ready = 'true';
    const cards = [...home.querySelectorAll('[data-bni-card]')];
    const grid = document.getElementById('bni-product-grid');
    const search = document.getElementById('bni-search');
    const status = document.getElementById('bni-results-status');
    const more = document.getElementById('bni-load-more');
    const empty = document.getElementById('bni-empty-results');
    const dialog = document.getElementById('bni-kit-dialog');
    const content = document.getElementById('bni-kit-content');
    const initialCount = home.hasAttribute('data-exp-shop') ? 16 : 8;
    let kind = 'all', visible = initialCount, lastTrigger = null;
    function render() {
      const term = search.value.trim().toLowerCase();
      const matches = cards.filter(card => (kind === 'all' || card.dataset.kind === kind || kind === 'halloween' && card.dataset.spooky === 'true') && card.dataset.search.includes(term));
      const shown = new Set(matches.slice(0, visible));
      cards.forEach(card => { card.hidden = !shown.has(card); });
      more.hidden = matches.length <= visible;
      empty.hidden = matches.length !== 0;
      status.textContent = status.dataset.countTemplate.replace('COUNT_SHOWN', Math.min(visible, matches.length)).replace('COUNT_TOTAL', matches.length);
    }
    function setFilter(value) {
      kind = value; visible = initialCount;
      home.querySelectorAll('[data-filter]').forEach(button => { const active = button.dataset.filter === kind; button.classList.toggle('bni-active', active); button.setAttribute('aria-pressed', String(active)); });
      render();
    }
    home.querySelectorAll('[data-filter]').forEach(button => button.addEventListener('click', () => setFilter(button.dataset.filter)));
    home.querySelectorAll('[data-choose]').forEach(a => a.addEventListener('click', () => { search.value = ''; setFilter(a.dataset.choose); }));
    search.addEventListener('input', () => { visible = initialCount; render(); });
    more.addEventListener('click', () => { visible += 8; render(); });
    if (dialog && typeof dialog.showModal === 'function') {
      home.querySelectorAll('[data-bni-kit]').forEach(button => { button.hidden = false; });
      grid.addEventListener('click', e => {
        const button = e.target.closest('[data-bni-kit]');
        if (!button) return;
        const template = document.getElementById('bni-kit-template-' + button.dataset.bniKit);
        if (!template) return;
        lastTrigger = button; content.replaceChildren(template.content.cloneNode(true));
        const select = content.querySelector('[data-bni-size]');
        const detailLink = content.querySelector('[data-bni-detail-link]');
        const detailBase = detailLink.getAttribute('href').split('?')[0];
        function updateSize() {
          const option = select.selectedOptions[0];
          if (!option) return;
          content.querySelector('[data-bni-price]').textContent = option.dataset.price;
          content.querySelector('[data-bni-submit]').disabled = option.dataset.available !== 'true';
          detailLink.href = detailBase + '?variant=' + encodeURIComponent(option.value);
        }
        select.addEventListener('change', updateSize); updateSize(); dialog.showModal();
      });
      dialog.querySelector('.bni-close-dialog').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', e => { if (e.target !== dialog) return; const r = dialog.getBoundingClientRect(); if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) dialog.close(); });
      dialog.addEventListener('close', () => { content.replaceChildren(); lastTrigger?.focus(); });
    }
    render();
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (!reduced.matches && 'IntersectionObserver' in window) {
      document.body.classList.add('bni-motion-ready');
      const observer = new IntersectionObserver(entries => entries.forEach(entry => { if (entry.isIntersecting) { entry.target.classList.add('bni-is-visible'); observer.unobserve(entry.target); } }), { threshold: .08 });
      home.querySelectorAll('.bni-reveal').forEach(element => observer.observe(element));
    }
    let pending = false;
    const onScroll = () => {
      if (pending) return; pending = true;
      requestAnimationFrame(() => { const y = window.scrollY; header?.classList.toggle('bni-scrolled', y > 35); if (!reduced.matches && y < 1000) home.querySelector('.bni-hero-art')?.style.setProperty('--hero-shift', Math.min(y * .08, 55) + 'px'); pending = false; });
    };
    window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initBni); else initBni();
  document.addEventListener('shopify:section:load', initBni);
})();
  } catch(e) { console.error(e); }
})();

})();
